import { getCurrentUser, useUserStore } from 'store/user';
import { LocalStorageManager } from 'services/storage/LocalStorageManager';
import {
  CurrentUserIdentity,
  unknownUserIdentity,
} from 'shared/domain/currentUser/currentUserIdentity';

/**
 * The logged-in user: from the store, or from the last sign-in while the
 * store is still empty (reload, restored session).
 */
export function getCurrentUserIdentity(): CurrentUserIdentity {
  const user = getCurrentUser();
  return {
    id: user?._id || LocalStorageManager.getUserIdSilent() || unknownUserIdentity.id,
    email: user?.email || LocalStorageManager.getUserEmailSilent() || unknownUserIdentity.email,
  };
}

/** Calls the handler with the identity now and each time the logged-in user changes. */
export function subscribeToCurrentUserIdentity(
  handler: (identity: CurrentUserIdentity) => void
): () => void {
  handler(getCurrentUserIdentity());
  return useUserStore.subscribe((state, prevState) => {
    if (state.user !== prevState.user) {
      handler(getCurrentUserIdentity());
    }
  });
}
